import app from './app.js'
import TWEEN from './tween.js'
const THREE = require('three')

Object.assign(app.__proto__, {

    //选中模型变色
    changeSelectDye: function(group, o) {

        //如果是正经之类的就不变色
        searchLoop(group.children)

        function searchLoop(group) {

            group.forEach(function(child) {

                if (o && app.flag.animate && (child.role === 'ZJ' || child.role === 'JB' || child.role === 'LM')) return

                if (child.type === "Mesh") {
                    //尺子不变色
                    if (child.role === 'CHI') {} else {
                        let aa = child.material
                        if (o) {
                            aa.color = app.selectColor
                            
                        } else {
                            aa.color = aa.originalColor
                            
                        }
                    }
                } else {
                    return searchLoop(child.children)
                }
            })
        }
    },

    //点中系统解剖mesh方法
    clickOption: function(parent) {

        //清除上次选中颜色
        if (app.mmObj) {
            app.changeMMDye(false)
            app.mmObj = null
        }

        //如果之前点击的正好是当前选中
        if (app.selectObj[0] === parent) {
            this.handleSelectObjbeforClickNewObj()
            app.optionBar.setState({
                show: false
            })
        } else {
            this.handleSelectObjbeforClickNewObj()
            app.selectObj.push(parent)
            app.changeSelectDye(parent, true)
            app.preOpt = null
            app.optionBar.upDateOptionBarState()
            //系统模型操作面板
            app.optionBar.setState({
                show: true,
                cnName: parent.cnName || null,
                sysNote: parent.sysNote
            })
        }

        app.tapComponent.setState({
            tapIndex:parent.oIndex
        })


    },

    //点击新的模型之前处理老的模型
    handleSelectObjbeforClickNewObj() {
        if (!app.selectObj.length) return
        //清除颜色
        app.resetSelectObjColor()
        app.selectObj = []
    },


    //
    lookSearchMesh(Group) {
        let pos
        if (Group.children && Group.children.length === 1) {
            try {
                pos = app.calcPosition(Group.children[0]) || null
            } catch (err) {
                console.log(err)
                return
            }

            new TWEEN.Tween(app.controls.target)
                .to({ x: pos.x, y: pos.y, z: pos.z }, 800)
                .easing(TWEEN.Easing.Exponential.Out)
                .start()
                .onUpdate(() => {
                    app.camera.lookAt(app.controls.target)
                })
        }

    },



    //把当前group从选中模型中剔除
    rejectGroupFromOptionObj: function(group) {
        if (!group || !app.selectObj.length) return
        app.selectObj.forEach(function(Oitem, Oindex) {
            if (Oitem.length) {
                for (let i = 0; i < Oitem.length; i++) {
                    if (group === Oitem[i]) {
                        Oitem.splice(i, 1)
                        if (!Oitem.length) {
                            app.selectObj.splice(Oindex, 1)
                        }
                        break
                    }
                }
            } else {
                if (group === Oitem) {
                    app.selectObj.splice(Oindex, 1)
                }
            }
        })
    },



    //显示隐藏方法
    hideAndShowGroup: function(group, show) {

        if (!group.children) return

        if (group.treeObj) {
            group.treeObj.setState({
                checked: show
            })
        }

        searchLoop(group.children)

        function searchLoop(group) {

            group.forEach(function(child, index) {

                if (child.type === "Mesh") {
                    child.visible = show
                } else {
                    return searchLoop(child.children)
                }

            })

        }

    },

    //显示隐藏操作  选中的
    hideAndShowSelectObjGroupOption: function(show, cancelOption) {

        if (!cancelOption) {
            if (show) {
                app.opt.show.push(app.selectObj)
                app.opt.step.push(1)
            } else {
                app.opt.hide.push(app.selectObj)
                app.opt.step.push(2)
            }
        }

        for (var i = 0; i < app.selectObj.length; i++) {
            if (app.selectObj[i].length) {
                for (let j = 0; j < app.selectObj[i].length; j++) {
                    app.hideAndShowGroup(app.selectObj[i][j], show)
                }
            } else {
                app.hideAndShowGroup(app.selectObj[i], show)
            }
        }

    },


    //隐藏显示其他的
    hideAndShowOthterGroupOption: function(show) {
        //暂存当前选中的
        let tempSelectObj = app.selectObj
        let othterMeshArr = []
        app.optionObj.forEach(function(Oitem) {
            let parent = Oitem.dataParent || null
            //反选，并且当前group是显示状态才选中

            othterMeshArr.push(parent)
            
        })
        //console.log(othterMeshArr)
        //app.clearSelectObj()
        app.selectObj = []
        app.selectObj.push(othterMeshArr)
        app.hideAndShowSelectObjGroupOption(show)
        app.selectObj = tempSelectObj
    },

    //透明其他模型 选中操作
    opacityOtherGroupOption: function(opacity) {
        if (!app.selectObj.length) return
        //暂存当前选中的
        let tempSelectObj = app.selectObj
        let othterMeshArr = []
        app.optionObj.forEach(function(Oitem) {
            let parent = Oitem.dataParent
            //反选 显示状态才选中
            if (parent && parent.treeObj.checked === true && parent.treeObj.selected === false) {
                othterMeshArr.push(parent)
            }
        })
        //app.clearSelectObj()
        app.selectObj = []
        app.selectObj.push(othterMeshArr)
        app.opacityGroupOption(opacity)
        app.selectObj = tempSelectObj
    },

    //透明选中模型
    opacityGroupOption: function(opacity, cancelOption) {

        if (!cancelOption) {
            //如果是透明就放入3
            if (opacity) {
                app.opt.opacity.push(app.selectObj)
                app.opt.step.push(3)
                //如果是实体就放入4
            } else {
                app.opt.opaque.push(app.selectObj)
                app.opt.step.push(4)
            }
        }

        for (var i = 0; i < app.selectObj.length; i++) {
            if (app.selectObj[i].length) {
                for (let j = 0; j < app.selectObj[i].length; j++) {
                    app.opacityGroup(app.selectObj[i][j], opacity)
                }
            } else {
                app.opacityGroup(app.selectObj[i], opacity)
            }
        }
    },

    //透明group的方法
    opacityGroup: function(group, opacity) {


        if (!group.children) return

        group.opacity = opacity

        searchLoop(group.children)

        function searchLoop(group) {

            group.forEach(function(child, index) {

                if (child.type === "Mesh") {
                    if (opacity) {
                        child.material.opacity = .2
                    } else {
                        child.material.opacity = 1
                    }
                } else {
                    child.opacity = opacity
                    return searchLoop(child.children)
                }
            })
        }
    },


    //点击根系统时把组添加到option中 并且显示该group
    appendAndrejectGroup: function(group, show) {

        searchLoop(group.children)

        group.treeObj.setState({
            checked: show
        })

        function searchLoop(group) {
            group.forEach(function(child, index) {
                if (child.type === "Mesh") {
                    if (show) {
                        child.visible = show
                        //剔除obj
                        app.optionObj.push(child)

                        if (child.role === 'XWMESH' && !child.dataParent.createdSprite) {
                            //如果还没有精灵图， 就创建精灵图
                            app.handleXueweiSprite(child)
                        }

                    } else {
                        child.visible = false
                        //剔除obj
                        app.rejectObj(child)
                    }
                } else {
                    return searchLoop(child.children)
                }
            })
        }
    },

    //剔除obj
    rejectObj: function(item) {

        //从optionObj中剔除隐藏系统的mesh
        app.optionObj.forEach(function(Oitem, Oindex) {
            if (item === Oitem) {
                app.optionObj.splice(Oindex, 1)
            }
        })
        //从selectObj中剔除隐藏系统的mesh
        app.selectObj.forEach(function(Oitem, Oindex) {
            if (item === Oitem) {
                app.selectObj.splice(Oindex, 1)
            }
        })
    },

    //清除所有的a选中颜色
    resetSelectObjColor: function() {
        if (!app.selectObj.length) return
        let len = app.selectObj.length
        for (var i = 0; i < len; i++) {
            if (app.selectObj[i].length) {
                for (var j = 0; j < app.selectObj[i].length; j++) {
                    app.changeSelectDye(app.selectObj[i][j], false)
                }
            } else {
                app.changeSelectDye(app.selectObj[i], false)
            }
        }
    },

    //返回上一步
    cancelOptionFn: function() {

        let opt = app.opt
        let stepFlag
        if (opt.step.length) {
            stepFlag = opt.step.pop()
        } else {
            return
        }

        this.handleSelectObjbeforClickNewObj()

        //opt.step.splice(0, 1)

        switch (stepFlag) {


            //如果 上一步是显示操作 现在要隐藏
            case 1:

                if (opt.show.length) {
                    if (opt.show[0].length) {
                        for (let i = 0; i < opt.show[0].length; i++) {
                            app.selectObj.push(opt.show[0][i])
                        }
                    } else {
                        app.selectObj.push(opt.show[0])
                    }
                    opt.show.splice(0, 1)
                    app.hideAndShowSelectObjGroupOption(false, true)
                }

                break

                //如果 上一步是隐藏操作 现在要显示
            case 2:


                if (opt.hide.length) {

                    let item = opt.hide.pop()

                    if (item.length) {
                        for (let i = 0; i < item.length; i++) {
                            app.selectObj.push(item[i])
                        }
                    } else {
                        app.selectObj.push(item)
                    }
                    //opt.hide.splice(0, 1)

                    app.hideAndShowSelectObjGroupOption(true, true)
                }

                break

                // 上一步是透明操作 现在要显示
            case 3:

                if (opt.opacity.length) {

                    let item = opt.opacity.pop()

                    if (item.length) {
                        for (let i = 0; i < item.length; i++) {
                            app.selectObj.push(item[i])
                        }
                    } else {
                        app.selectObj.push(item)
                    }
                    //opt.hide.splice(0, 1)
                    app.opacityGroupOption(false, true)
                }


                break

                // 上一步是透明操作 现在要显示
            case 4:

                if (opt.opaque.length) {

                    let item = opt.opaque.pop()

                    if (item.length) {
                        for (let i = 0; i < item.length; i++) {
                            app.selectObj.push(item[i])
                        }
                    } else {
                        app.selectObj.push(item)
                    }
                    //opt.hide.splice(0, 1)
                    app.opacityGroupOption(true, true)
                }
                break

        }
    }

})


// WEBPACK FOOTER //
// ./src/pages/webgl/src/option.js